import { useEffect, useState } from 'react';
import { ManagerAuthorization } from '@common/enums';
import {
    AdminTable,
    EditButton,
    FullName,
    Header,
    Link,
    TableBody,
    TableData,
    TableHead,
    TableHeader,
    TableRow,
} from '@frontend/components/elements/common';
import { NullableFormattedDate } from '@frontend/components/elements/NullableFormattedDate';
import { fetchJson } from '@frontend/store/fetch';
import { translateKey } from '@frontend/translate';
import { assertHasAuthorization } from '@frontend/utils';

interface IOrganizationPractitionersListProps {
    organizationId: string;
}

interface IEmployment {
    id: string;
    patientsCount: number;
    practitioner: IOrganizationPractitioner;
    practitionerId: string;
}

interface IOrganizationPractitioner {
    emailAddress: string | null;
    lastLoginOn: Date | string | null;
    nameFamily: string;
    nameGiven: string | null;
    nameInfix: string | null;
}

export function OrganizationPractitionersList(props: IOrganizationPractitionersListProps) {
    const { organizationId } = props;
    const [employments, setEmploymnents] = useState<IEmployment[]>([]);

    assertHasAuthorization(ManagerAuthorization.employmentsOld);

    useEffect(() => {
        loadEmploymentsByOrganizationId(organizationId);
    }, [organizationId]);

    return (
        <>
            <Header content={translateKey('practitioner.practitioners')} />
            <AdminTable>
                <TableHead>
                    <TableRow>
                        <TableHeader>{translateKey('common.name')}</TableHeader>
                        <TableHeader>{translateKey('common.emailAddress')}</TableHeader>
                        <TableHeader>{translateKey('practitioner.lastLogin')}</TableHeader>
                        <TableHeader align="right"></TableHeader>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {employments.map((employment) => (
                        <TableRow key={employment.id}>
                            <TableData>
                                <Link to={`/practitioners/${employment.practitionerId}?tab=Betrekkingen`}>
                                    <FullName
                                        nameFamily={employment.practitioner.nameFamily}
                                        nameGiven={employment.practitioner.nameGiven}
                                        nameInfix={employment.practitioner.nameInfix}
                                    />
                                </Link>
                            </TableData>
                            <TableData>{employment.practitioner.emailAddress || ''}</TableData>
                            <TableData>
                                <NullableFormattedDate value={employment.practitioner.lastLoginOn} />
                            </TableData>
                            <TableData>
                                <EditButton
                                    to={`/employments/${employment.id}?practitionerId=${employment.practitionerId}&organizationId=${organizationId}&returnTo=organization`}
                                />
                            </TableData>
                        </TableRow>
                    ))}
                </TableBody>
            </AdminTable>
        </>
    );

    async function loadEmploymentsByOrganizationId(id: string) {
        const url = `/api/employments/${id}/practitioners`;
        const result = await fetchJson(url, 'GET');
        setEmploymnents(result.json.items);
    }
}
